import { useTranslation } from "react-i18next";
import { AdoptionWidget } from "@/components/AdoptionWidget";
import { useAdoption } from "@/hooks/useAdoption";

interface AdoptionPanelProps {
  projectSlug: string;
}

export function AdoptionPanel({ projectSlug }: AdoptionPanelProps) {
  const { t } = useTranslation();
  const { data, loading } = useAdoption(projectSlug);

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">{t("adoption.title")}</h2>
      {loading ? (
        <p className="text-muted-foreground">{t("dashboard.loading")}</p>
      ) : !data ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16 text-center">
          <h3 className="text-sm font-medium text-foreground mb-1">
            {t("adoption.quality.empty")}
          </h3>
          <p className="text-sm text-muted-foreground max-w-sm">
            {t("adoption.quality.emptyDetail")}
          </p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <AdoptionWidget projectSlug={projectSlug} />
        </div>
      )}
    </div>
  );
}
